import { createContext } from 'react';
/**
 * This context is used to set various theming options internally, such as the
 * theme name, icons and design tokens.
 */

var ThemeContext = createContext({});
export default ThemeContext;